import type { Track } from '@/class/Track';

/**

 * */
export function checkTrackListOverlap(trackList: Track[], checkItem: Track, moveIndex = -1) {
    const { start: insertStart, end: insertEnd } = checkItem;
    let overLapIndex = -1;
    let insertIndex = 0;
    const hasOverlap = trackList.some((trackItem, index) => {
        if (moveIndex !== -1 && index === moveIndex) { 
            return false;
        }
        const { start, end } = trackItem;
        
        if (
            (start <= insertStart && end >= insertEnd) 
            || (start >= insertStart && start < insertEnd) 
            || (end > insertStart && end <= insertEnd) 
        ) {
            overLapIndex = index;
            return true;
        } else {
            if (end <= insertStart) {
                insertIndex = index + 1;
            }
            return false;
        }
    });
    return {
        hasOverlap,
        overLapIndex,
        insertIndex
    };
}
